<template>
  <a v-if="hasPhone" :href="'tel:' + phoneNumber">
    <i class="icon">
      <Icon name="fa6-solid:phone-flip" />
    </i>
    <span>
      {{ phoneNumber }}
    </span>
    <span v-if="hasLabel">
      {{ '&nbsp;' + phoneLabel }}
    </span>
  </a>
  <div v-else-if="hasLabel">
    <i class="icon">
      <Icon name="fa6-solid:phone-flip" />
    </i>
    <span>
      {{ phoneLabel }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { BlockPhoneStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockPhoneStoryblok
}>()
const phoneNumber = computed(() => props.blok?.phone)
const phoneLabel = computed(() => props.blok?.label)
const hasLabel = computed(() => !!props.blok?.label)
const hasPhone = computed(() => !!props.blok?.phone)
</script>
